export const SET_ADDING_ANIM = 'SET_ADDING_ANIM'
export const ADD_ADDING_ANIM = 'ADD_ADDING_ANIM'
export const REMOVE_ADDING_ANIM = 'REMOVE_ADDING_ANIM'
export const CLEAR_ADDING_ANIM = 'CLEAR_ADDING_ANIM'
